module.exports = __webpack_public_path__ + "fork_right.svg?a4926862a886ce28d7ffcb9761eedab3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/fork_right.svg
// module id = 166
// module chunks = 0